module.exports = __webpack_public_path__ + "img/type_1.754b366f.png";